// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/v1/exchange.proto (package mochabugapis.adapt.graph.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Transceiver, TransceiverJson } from "./transceiver_pb";
import { file_mochabugapis_adapt_graph_v1_transceiver } from "./transceiver_pb";
import type { Transmitter, TransmitterJson } from "./transmitter_pb";
import { file_mochabugapis_adapt_graph_v1_transmitter } from "./transmitter_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/v1/exchange.proto.
 */
export const file_mochabugapis_adapt_graph_v1_exchange: GenFile = /*@__PURE__*/
  fileDesc("Ciptb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvdjEvZXhjaGFuZ2UucHJvdG8SG21vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MSKcBAoIRXhjaGFuZ2USMwoEbmFtZRgBIAEoCUIlukgiciAQARgyMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJBIcCgVsYWJlbBgCIAEoCUIIukgFcgMY+gFIAIgBARIiCgtkZXNjcmlwdGlvbhgDIAEoCUIIukgFcgMY6AdIAYgBARLFAQoMdHJhbnNtaXR0ZXJzGAQgAygLMigubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLnYxLlRyYW5zbWl0dGVyQoQBukiAAboBeAoZdHJhbnNtaXR0ZXJzX3VuaXF1ZV9uYW1lcxIpRWFjaCB0cmFuc21pdHRlciBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aMHRoaXMubWFwKHRyYW5zbWl0dGVyLCB0cmFuc21pdHRlci5uYW1lKS51bmlxdWUoKZIBAhAyErYBCglyZWNlaXZlcnMYBSADKAsyKC5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGgudjEuVHJhbnNjZWl2ZXJCebpIdroBbAoWcmVjZWl2ZXJzX3VuaXF1ZV9uYW1lcxImRWFjaCByZWNlaXZlciBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aKnRoaXMubWFwKHJlY2VpdmVyLCByZWNlaXZlci5uYW1lKS51bmlxdWUoKZIBBAgBEDJCCAoGX2xhYmVsQg4KDF9kZXNjcmlwdGlvbmIGcHJvdG8z", [file_buf_validate_validate, file_mochabugapis_adapt_graph_v1_transceiver, file_mochabugapis_adapt_graph_v1_transmitter]);

/**
 * Exchange represents a communication setup involving both transmitters
 * (outputs) and receivers (inputs). Outputs use the Transmitter type with a
 * Mode enum (STANDARD / STREAM / FAILURE); inputs use the lean Transceiver type.
 *
 * @generated from message mochabugapis.adapt.graph.v1.Exchange
 */
export type Exchange = Message<"mochabugapis.adapt.graph.v1.Exchange"> & {
  /**
   * Identifier for the exchange, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional human-readable label for the exchange, up to 250 characters.
   *
   * @generated from field: optional string label = 2;
   */
  label?: string | undefined;

  /**
   * Optional descriptive text for the exchange, up to 1000 characters.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * Outputs of the exchange. MODE_STANDARD and MODE_FAILURE are single-shot;
   * MODE_STREAM emits multiple times.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Transmitter transmitters = 4;
   */
  transmitters: Transmitter[];

  /**
   * Inputs of the exchange. Parent supplies these at dispatch time.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Transceiver receivers = 5;
   */
  receivers: Transceiver[];
};

/**
 * Exchange represents a communication setup involving both transmitters
 * (outputs) and receivers (inputs). Outputs use the Transmitter type with a
 * Mode enum (STANDARD / STREAM / FAILURE); inputs use the lean Transceiver type.
 *
 * @generated from message mochabugapis.adapt.graph.v1.Exchange
 */
export type ExchangeJson = {
  /**
   * Identifier for the exchange, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Optional human-readable label for the exchange, up to 250 characters.
   *
   * @generated from field: optional string label = 2;
   */
  label?: string;

  /**
   * Optional descriptive text for the exchange, up to 1000 characters.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * Outputs of the exchange. MODE_STANDARD and MODE_FAILURE are single-shot;
   * MODE_STREAM emits multiple times.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Transmitter transmitters = 4;
   */
  transmitters?: TransmitterJson[];

  /**
   * Inputs of the exchange. Parent supplies these at dispatch time.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Transceiver receivers = 5;
   */
  receivers?: TransceiverJson[];
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.Exchange.
 * Use `create(ExchangeSchema)` to create a new message.
 */
export const ExchangeSchema: GenMessage<Exchange, {jsonType: ExchangeJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_exchange, 0);

